module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.734 8.281\"><path id=\"パス_2275\" data-name=\"パス 2275\" d=\"M2870.494,1343.392l-5.453-5.453-5.453,5.453\" transform=\"translate(-2858.174 -1336.525)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/arrow_up.svg
// module id = h8ZH
// module chunks = 1